const ChallengesUtilizationCard = ({ title1 = '', title2 = '', liner1 = '', liner2 = '', classes='' }) => {
  return (
    <div className={`bg-white border border-gray-275 rounded-lg flex flex-row items-center justify-center ${classes} text-center`}>
      <div>
        <h1 className='text-3xl text-gray-900 mb-0 font-semibold'>{title1}</h1>
        <p className='text-sm text-gray-500 mb-0 mt-1 font-semibold'>{liner1}</p>
      </div>
      <hr className="border-r h-3/5 border-gray-200"/>
      <div>
        <h1 className='text-3xl text-gray-900 mb-0 font-semibold'>{title2}</h1>
        <p className='text-sm text-gray-500 mb-0 mt-1 font-semibold'>{liner2}</p>
      </div>
    </div>
  )
}
  
export default ChallengesUtilizationCard